import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { makeStyles, theme, Tooltip, IconButton } from '@archer-technologies/ui-components';
import { createElement } from 'react';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Popover } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
var _excluded = ["onToggle", "getMessage", "buttonRef", "active"],
    _excluded2 = ["visible", "onHide", "children", "target"],
    _excluded3 = ["item", "disabled", "onToggle"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var useStyles = makeStyles(function () {
  return {
    checkbox: {
      padding: 0
    },
    itemText: {
      paddingLeft: theme.spacing(1),
      '& span': {
        fontSize: '0.875rem'
      }
    },
    chooserButton: {
      marginLeft: '0.5rem'
    }
  };
});

var ToggleButtonComponent = function ToggleButtonComponent(_ref) {
  var onToggle = _ref.onToggle,
      getMessage = _ref.getMessage,
      buttonRef = _ref.buttonRef,
      active = _ref.active,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useStyles = useStyles(),
      chooserButton = _useStyles.chooserButton;

  var message = getMessage('showColumnChooser');
  var tooltipProps = {
    title: message,
    enterDelay: 300
  };

  var iconButtonProps = _objectSpread(_objectSpread({}, restProps), {}, {
    icon: 'Visibility',
    label: message,
    fontSize: 'large',
    onClick: onToggle
  });

  return /*#__PURE__*/createElement(Tooltip, _extends({}, tooltipProps, {
    placement: "bottom"
  }), /*#__PURE__*/createElement(IconButton, _extends({}, iconButtonProps, {
    ref: buttonRef,
    color: "primary",
    className: active ? "focusActive ".concat(chooserButton) : "".concat(chooserButton)
  })));
};

var ColumnChooserOverlay = function ColumnChooserOverlay(_ref2) {
  var visible = _ref2.visible,
      onHide = _ref2.onHide,
      children = _ref2.children,
      target = _ref2.target,
      restProps = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/createElement(Popover, _extends({
    open: visible,
    anchorEl: target,
    onClose: onHide,
    PaperProps: {
      elevation: 0,
      style: {
        boxShadow: '0 2px 10px 0 rgba(33, 33, 33, .40)'
      }
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, restProps), children);
};

var ColumnChooserItem = function ColumnChooserItem(_ref3) {
  var _ref3$item = _ref3.item,
      column = _ref3$item.column,
      hidden = _ref3$item.hidden,
      disabled = _ref3.disabled,
      onToggle = _ref3.onToggle,
      restProps = _objectWithoutProperties(_ref3, _excluded3);

  var _useStyles2 = useStyles(),
      checkbox = _useStyles2.checkbox,
      itemText = _useStyles2.itemText;

  if (column.name !== 'actions') {
    return /*#__PURE__*/createElement(ListItem, _extends({
      key: column.name,
      button: true,
      role: "listitem",
      component: "li",
      disabled: disabled,
      onClick: onToggle
    }, restProps), /*#__PURE__*/createElement(Checkbox, {
      checked: !hidden,
      inputProps: {
        'aria-label': column.title || column.name
      },
      tabIndex: -1,
      disableRipple: true,
      disabled: disabled,
      className: checkbox
    }), /*#__PURE__*/createElement(ListItemText, {
      className: itemText,
      primary: column.title || column.name
    }));
  } else {
    return null;
  }
};

export { ColumnChooserItem, ColumnChooserOverlay, ToggleButtonComponent };